var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.52 13.08C23.52 12.2296 23.4436 11.4119 23.3018 10.627H12V15.266H18.4582C18.18 16.7651 17.3345 18.0352 16.0636 18.8856V21.8947H19.9418C22.2109 19.8069 23.52 16.7324 23.52 13.08Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.999 24.8099C15.239 24.8099 17.9554 23.736 19.9408 21.9043L16.0627 18.8952C14.9881 19.6148 13.6136 20.04 11.999 20.04C8.87357 20.04 6.22812 17.9304 5.28448 15.0957H1.27539V18.2029C3.24994 22.1224 7.30812 24.8099 11.999 24.8099Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28545 15.0766C5.04545 14.357 4.90909 13.5884 4.90909 12.798C4.90909 12.0075 5.04545 11.2389 5.28545 10.5193V7.41211H1.27636C0.463636 9.03114 0 10.8628 0 12.798C0 14.7332 0.463636 16.5648 1.27636 18.1838L5.28545 15.0766Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.999 5.58823C13.7608 5.58823 15.3427 6.19332 16.5863 7.38169L20.0281 3.94194C17.9499 2.00674 15.2336 0.818359 11.999 0.818359C7.30812 0.818359 3.24994 3.50584 1.27539 7.4253L5.28448 10.5325C6.22812 7.69787 8.87357 5.58823 11.999 5.58823Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c6b411cad6d2fa56f9b5867378273372.svg";
export { ForwardRef as ReactComponent };